module.exports = __webpack_public_path__ + "static/img/200.acfd9e99.png";